package com.essntl.core.waypoint.data.response

import kotlinx.serialization.Serializable

@Serializable
data class WaypointLogsResponse(
    val data: List<WaypointLogsData>,
)
